import { render, staticRenderFns } from "./ReplacementOrderAutomation.vue?vue&type=template&id=53246d09&scoped=true"
import script from "./ReplacementOrderAutomation.vue?vue&type=script&lang=js"
export * from "./ReplacementOrderAutomation.vue?vue&type=script&lang=js"
import style0 from "./ReplacementOrderAutomation.vue?vue&type=style&index=0&id=53246d09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53246d09",
  null
  
)

export default component.exports